import React from 'react';
import { Form } from 'react-bootstrap';
import "./Color.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const ColorPicker = ({ borderColor, onBorderColorChange, className }) => {
  const handleColorChange = (e) => {
    onBorderColorChange(e.target.value);
  };

  return (
    <Form.Group className={`color ${className}`}>
      <Form.Label>Set Border Color</Form.Label>
      <Form.Control
        type="color"
        value={borderColor || "#FFFFFF"}
        onChange={handleColorChange}
      />
      <FontAwesomeIcon icon={faXmark} style={{ color: 'red', fontSize: '18px', cursor: 'pointer' }} onClick={() => onBorderColorChange(null)} />
    </Form.Group>
  );
};

export default ColorPicker;
